// 联合策划
import { createAPI } from '@common'
export default {
  // 根据docLibID获取其根文件夹ID
  getRootIdByDocLibID: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0gpmefst0sppu', 'GET', config),
  // 根据docLibID获取其根文件夹ID
  getFoldersAdmin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0gpmefst0benjo', 'GET', config),
  // 根据docLibID获取其根文件夹ID权限
  getFolders: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60gpmefst', 'GET', config),
  // √ 读角色权限：文件夹操作权限
  getAdminPermissionsActionsFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0benjo0qfsnjttjpot0bdujpot0gpmefs',
      'GET',
      config
    ),
  // 保存角色权限：文件夹操作权限
  postAdminPermissionsActionsFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0benjo0qfsnjttjpot0bdujpot0gpmefs',
      'POST',
      config
    ),

  // 主题相关接口
  // /folders/root
  // 列表数据接口
  //   读取列表定义 e5/lists?params={docLib:1, folder:1, ...}  get
  getList: (config) => createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60mjtut', 'GET', config),
  //   读取列表数据  e5/listdata POST
  getListData: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60mjtuebub', 'POST', config),

  // 检索条件和操作接口
  // 检索条件 /e5/conditions
  getConditions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60dpoejujpot', 'GET', config),
  // 操作 /e5/actions
  getActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60bdujpot', 'GET', config),

  // 新建主题初始化
  getInitialization: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0upqjd0dsfbujpo0jojujbmj{bujpo',
      'GET',
      config
    ),
  // 新建主题页面获取租户列表
  getTenants: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0upqjd0ufobout', 'GET', config),
  // 保存主题
  postTheme: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0upqjd0dsfbuf', 'POST', config),
  // 获取详情
  getThemeDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0upqjd0efubjm', 'GET', config),
  // 删除主题
  delelteTheme: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0upqjd0efmfuf', 'POST', config),
  // 发布主题
  publishTheme: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0upqjd0qvcmjti', 'POST', config),

  // 主题稿件相关接口
  // 列表数据接口
  //    读取列表定义 e5/lists?params={docLib:1, folder:1, ...} get
  //    读取列表数据 e5/listdata POST
  // 检索条件和操作接口
  //    检索条件 /e5/conditions
  //    操作  /e5/actions

  // 新建主题稿件初始化
  getArticleInitialization: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0upqjd0bsujdmf0dsfbujpo0jojujbmj{bujpo',
      'GET',
      config
    ),
  // 获取租户列表
  getArticleTenants: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0upqjd0bsujdmf0ufobout', 'GET', config),
  // 保存主题稿件
  postArticle: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0upqjd0bsujdmf0dsfbuf', 'POST', config, {
      ...vconfig,
      isSimpleSecurity: true
    }),
  // 获取主题稿件详情
  getArticleDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0upqjd0bsujdmf0efubjm', 'GET', config),
  // 提交稿件
  postSubmitArticle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0upqjd0bsujdmf0tvcnju', 'POST', config),
  // 删除稿件
  delelteArticle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0upqjd0bsujdmf0efmfuf', 'POST', config),
  // 选用稿件
  selectArticle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0upqjd0bsujdmf0tfmfdu', 'POST', config),
  // 选用列表
  selectArticleList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0upqjd0bsujdmf0tfmfdu0mjtu', 'GET', config),
  // 流程记录
  actionsLogs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60bdujpot0mpht', 'GET', config),
  // 检查是否只有一个文件夹的权限
  getPrecheck: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0upqjd0qsfdifdl', 'GET', config)
}
